import React, { Component, createRef } from 'react';
import { observer } from 'mobx-react';
import { translate } from 'react-i18next';
import Flight from '../../Store/Flight';
import FlightBookingRequest from '../../Store/Booking/FlightBookingRequest';
import { Row, Col, Container, Button } from 'reactstrap';
import FlightDetails from './FlightDetails';
import ClientInfo from '../ClientInfo';
import PassengerInfo from '../PassengerInfo';
import ProcessingModal from '../ProcessingModal';
import CheckoutSection from '../CheckoutSection';

type Props = {
  params: any
};

@observer
export class FlightBookingScreen extends Component {

  state: {
    flight: Flight,
    booking: FlightBookingRequest,
    step: number,
    isOpen: boolean
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      flight: null,
      booking: null,
      isOpen: false,
      step: 1, // 1 for Client and Passenger info, 2 for Checkout
    };
  }

  componentWillMount() {
    const { location: { query }, params: { flightId } } = this.props;
    this.load(flightId, query.passengers);
  }

  async load(flightId: string, passengerCount: number) {
    const flight = await Flight.get(flightId);
    const booking = new FlightBookingRequest({ flight });
    booking.setPassengerCount(passengerCount);

    if (booking.promo_code.code) {
      booking.applyDiscounts();
    }

    this.setState({ flight, booking });
  }

  handleBooking = (token) => {
    const { booking } = this.state;
    if (token) {
      booking.payment.token = token.id;
    }
    this.setState({ isOpen: true });
  };

  handleModalClose = (success) => {
    if (success) {
      this.props.router.replace('/');
    } else {
      this.setState({ isOpen: false });
    }
  };

  nextStep = () => {
    this.setState({ step: 2 }, () => {
      window.scrollTo(0, 0);
    });
  };

  previousStep = () => {
    this.setState({ step: 1 }, () => {
      window.scrollTo(0, 0);
    });
  };

  renderStep() {
    const { step, booking, flight, submitting, error } = this.state;
    const { t } = this.props;
    const title = flight.aircraft_offer.flight_offer.title;

    if (step === 1) {
      return (
        <div>
          <Row>
            <Col className='mb-4'>
              <h1 className='mb-1'>{t('Booking: {{title}}', { title })}</h1>
              <div>{t('Step 1/2')}</div>
            </Col>
          </Row>
          <Row className='align-items-stretch mb-4'>
            <Col md='6'>
              <ClientInfo
                client={booking}
              />
            </Col>
            <Col md='6'>
              <PassengerInfo
                booking={booking}
                enabled={booking.validClient}
              />
            </Col>
          </Row>
          <Row>
            <Col className='text-right'>
              <Button
                color='primary'
                onClick={this.nextStep}
                disabled={!booking.validClient || !booking.check_insurance_info || !booking.check_safety_info}
              >{t('Continue to payment')}</Button>
            </Col>
          </Row>
        </div>
      );
    } else if (step === 2) {
      return (
        <div>
          <Row>
            <Col className='mb-4'>
              <h1 className='mb-1'>{t('Payment: {{title}}', { title })}</h1>
              <div>{t('Step 2/2')}</div>
            </Col>
          </Row>
          <Row>
            <Col>
              <CheckoutSection
                enabled={booking.validClient}
                booking={booking}
                handlePayment={this.handleBooking}
                showSubmitButton={false}
              />
            </Col>
          </Row>

          {/*buttons*/}
          <Row>
            <Col sm={12} md={6} className='mb-4 mb-md-0'>
              <Button size='lg' color='secondary' className='d-block d-md-inline'
                      onClick={this.previousStep}>{t('Back to Info')}</Button>
            </Col>
            <Col sm={12} md={6} className='text-right'>
              {booking.payment.name === 'ONLINE' ? (
                <Button
                  color='primary'
                  size='lg'
                  disabled={booking.invalid || submitting}
                  className='d-block d-md-inline-block'
                  type='submit'
                  form='bookingForm'
                >
                  {submitting ? t('Sending...') : t('Buchen')}
                </Button>
              ) : (
                <Button
                  color='primary'
                  size='lg'
                  className='d-block d-md-inline-block'
                  disabled={booking.invalid}
                  onClick={this.handleBooking}
                >
                  {t('Buchen')}
                </Button>
              )}
            </Col>
          </Row>
        </div>
      );
    }
    return null;
  }

  render() {
    const { flight, booking } = this.state;
    const { t } = this.props;

    if (flight) {
      return (
        <Container>
          {this.renderStep()}
          <ProcessingModal
            booking={booking}
            isOpen={this.state.isOpen}
            onCloseRequest={this.handleModalClose}
            endpoint='flightbooking'
          />
        </Container>
      );
    }
    return null;
  }
}

export default translate()(FlightBookingScreen);



// WEBPACK FOOTER //
// ./src/App/Booking/Flight/index.js